import { render } from "./Assets.vue?vue&type=template&id=66566517"
import script from "./Assets.vue?vue&type=script&lang=js"
export * from "./Assets.vue?vue&type=script&lang=js"

import "./Assets.vue?vue&type=style&index=0&id=66566517&lang=less"
script.render = render

export default script